module.exports = __webpack_public_path__ + "img/banner-1.52e098fe.jpg";